
  import { Component, Vue } from 'vue-property-decorator';
  import { IWallboardNetwork, IWallboardTask, WallboardNetwork, WallboardTask } from './WallboardModels';
  import * as ColorUtils from '@/utilities/color.utils';

  @Component({
    props: {
      network: {
        type: Object as () => IWallboardNetwork,
        required: true
      },
    }
  })
  export default class WallboardTable extends Vue {

    get networkStyle() {
      // const darkColor: string = this.shadeHexColor(this.$props.block.networkHexColor, -30);

      const darkColor: string = ColorUtils.lightenDarkenColor('#' + this.$props.network.hexColor, -80);

      const theStyle = {
        background: '#' + this.$props.network.hexColor,
        color: '#FFFFFF',
        border: darkColor + ' 1px solid'
      };
      return theStyle;
      // return { background: this.$props.job.network.hexColor, color: darkColor, border: darkColor + ' 1px solid' };
    }
  }
